module.exports = __webpack_public_path__ + "src/assets/images/icon-guy.png?e3b3a5aaa0a79ba80c88e3c1a3a6ac31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-guy.png
// module id = 1002
// module chunks = 1